import React, { useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';

import { input } from '$gbusiness/helpers';
import { FormSection } from '$gcomponents/reusables';
import { Button, Text } from '$gcomponents/primitives';

import { SHIPPING_FORM } from './shippingForm';
import { AppForm } from '$styles/general';
import MuiModal from '$gcomponents/reusables/modal/material';
import intl from '$intl';
import { factoryActions } from '$fbusiness/redux/factory';
import { AppModel } from '$business/redux/';
import ShippingModel from '$fbusiness/models/shipping';

interface ShippingModalScreenProps {
  shipping: ShippingModel;
  onClose: Function;
}

const ShippingModalScreen: React.FC<ShippingModalScreenProps> = ({ shipping, onClose }) => {
  const dispatch = useDispatch();
  const isFinished = useSelector((state: AppModel) => state.factory.isFinished);
  const formRef = useRef<any>();

  useEffect(() => {
    if (!isFinished) return;

    dispatch(factoryActions.resetFinished());
    onClose();
  }, [isFinished, onClose, dispatch]);

  if (!shipping) return null;
  const { id, ...initialValues } = shipping;

  const onSubmit = values => {
    dispatch(factoryActions.saveShipping(id || 0, values));
  };

  const validateForm = values => input.validateError(SHIPPING_FORM, values);

  return (
    <Formik
      innerRef={formRef}
      enableReinitialize={true}
      initialValues={initialValues}
      validate={validateForm}
      onSubmit={values => {
        onSubmit(values);
      }}>
      {formik => (
        <MuiModal
          open={!!shipping}
          width="400px"
          onClose={() => onClose()}
          title={intl('SCREEN.FACTORY.SHIPPING_TITLE')}
          footer={
            <Button fullWidth onClick={formik.handleSubmit} disabled={!(formik.isValid && formik.dirty)}>
              <Text k="BUTTON.SAVE" />
            </Button>
          }>
          <div className="content">
            <AppForm>
              <FormSection FORM={SHIPPING_FORM} formik={formik} />
            </AppForm>
          </div>
        </MuiModal>
      )}
    </Formik>
  );
};

export default ShippingModalScreen;
